import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение списка организаций
    async getOrganizations(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);

      return await this.get(`organizations?${params.toString()}${sorting}`);
    },
    // Получение организации по id
    async getOrganizationById(id) {
      return await this.get(`organizations/id/${id}`);
    },
    // Создание организации
    async postOrganization(data) {
      return await this.post('organizations', data);
    },
    // Изменение организации
    async putOrganization(data) {
      return await this.put(`organizations/${data.id}`, data);
    },
    // Удаление организации
    async deleteOrganization(data) {
      return await this.delete(`organizations/${data.id}`, null);
    },
    // Получение организации по запросу
    async getOrganizationsSearch(query) {
      return await this.get(`organizations/search?query=${query}`);
    },

    // Получение печатей организации
    async getStamps(id) {
      return await this.get(`organizations/${id}/stamp`);
    },
    // Отправка печатей организации
    async postOrganizationFiles(organizationId, data) {
      return await this.post(`organizations/${organizationId}/stamp`, data);
    },
    async getOrganizationFile(organizationId, type) {
      return await this.getFile(`organizations/${organizationId}/file/${type}`);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/organizations.js